import styled from "@emotion/styled";
import InnoIcons from "@InnoIcons/";
import theme from "@theme";

const BodyHeader = styled.div`
  padding: 16px 24px;
  background: ${theme.gradient.modernGlass};
  backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(227, 110, 0, 0.1);
  position: fixed;
  width: 100%;
  z-index: 1000;
  box-shadow: ${theme.modernTokens.shadows.sm};
`;

const BodyContainer = styled.div`
  margin-top: 60px;
`;

const HeadingTag = styled.p`
  float: left;
  margin: 8px;
  padding: 0px 24px 0px 0px;
  font-weight: 600;
  font-size: 16px;
  color: ${theme.colors.modernGray[800]};
`;

const FilterContainer = styled.div`
  border-bottom: 1px solid rgba(227, 110, 0, 0.1);
  padding: 16px 24px;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
`;

const FilterOption = styled.p`
  padding: 8px 0px;
  font-weight: 500;
  color: ${theme.colors.modernGray[700]};
`;

const Container = styled.div`
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(15px);
  border-radius: ${theme.modernTokens.borderRadius.lg};
  box-shadow: ${theme.modernTokens.shadows.md};
  border: 1px solid rgba(255, 255, 255, 0.2);
  margin: 16px;
  transition: ${theme.modernTokens.transitions.normal};

  &:hover {
    box-shadow: ${theme.modernTokens.shadows.lg};
  }
`;

const ActiveContainer = styled.div`
  padding: 24px;
  display: flex;
  align-items: center;
`;

const ImageContainer = styled.div`
  width: 150px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${theme.modernTokens.borderRadius.md};
  border: 1px solid rgba(227, 110, 0, 0.2);
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
`;

const Image = styled.div`
  width: 130px;
  height: 80px;
  border: 2px solid rgba(227, 110, 0, 0.3);
  border-radius: ${theme.modernTokens.borderRadius.md};
  overflow: hidden;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
`;

const ProjectDiv = styled.div`
  margin-left: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const PropertyName = styled.span`
  font-weight: 700;
  font-size: 20px;
  text-transform: uppercase;
  background: ${theme.gradient.modernPrimary};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

const Status = styled.div`
  color: ${(props) =>
    props.currentProject.status === 1
      ? theme.colors.modernSuccess
      : theme.colors.modernError};
  font-weight: 600;
  font-size: 16px;
  margin: 8px 0px;
  padding: 4px 12px;
  background: rgba(16, 185, 129, 0.1);
  border-radius: ${theme.modernTokens.borderRadius.full};
  display: inline-block;
`;

const Email = styled.span`
  font-size: 16px;
  color: ${theme.colors.modernGray[600]};
  font-weight: 500;
`;

const Table = styled.table`
  width: 200px;
`;

const Thead = styled.thead``;

const Tbody = styled.tbody``;

const TR = styled.tr``;

const Th = styled.th`
  background: ${theme.gradient.modernPrimary};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  border-bottom: 1px solid rgba(227, 110, 0, 0.2);
  text-align: left;
  font-weight: 600;
  padding: 12px;
`;

const Tr = styled.tr`
  margin-bottom: 20px;
`;

const Td = styled.td`
  border-bottom: 1px solid rgba(227, 110, 0, 0.1);
  padding: 12px;
  color: ${theme.colors.modernGray[600]};
`;

const InputStyle = styled.input`
  width: 100%;
  height: 40px;
  padding: 12px 12px 12px 40px;
  font-size: 14px;
  border: 1px solid rgba(227, 110, 0, 0.2);
  border-radius: ${theme.modernTokens.borderRadius.md};
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  transition: ${theme.modernTokens.transitions.normal};

  &:focus {
    outline: none;
    border-color: ${theme.colors.modernPrimary};
    box-shadow: 0 0 0 3px rgba(227, 110, 0, 0.1);
  }

  &::placeholder {
    color: ${theme.colors.modernGray[400]};
  }
`;

const SearchIcon = styled(InnoIcons.SearchIcon)`
  position: absolute;
  left: 12px;
  color: ${theme.colors.modernGray[400]};
  font-size: 20px;
`;

const InputContiner = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 500px;
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  gap: 8px;
`;

const HeaderStyle = styled.div`
  font-size: 18px;
  font-weight: 600;
  background: ${theme.gradient.modernPrimary};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -0.3px;
`;

const CountStyle = styled.span`
  font-size: 14px;
  font-weight: 600;
  background: ${theme.gradient.modernPrimary};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  padding: 4px 12px;
  background: rgba(227, 110, 0, 0.1);
  border-radius: ${theme.modernTokens.borderRadius.full};
  border: 1px solid rgba(227, 110, 0, 0.2);
`;

const TabDiv = styled.div`
  display: flex;
  gap: 20px;
  padding: 16px 24px;
  margin: 0px 20px 0px 20px;
  align-items: baseline;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  border-radius: ${theme.modernTokens.borderRadius.md};
  border: 1px solid rgba(227, 110, 0, 0.1);
`;

const PopoverContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const PopoverSpan = styled.span`
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  border-radius: ${theme.modernTokens.borderRadius.md};
  padding: 8px 12px;
  border: 1px solid rgba(227, 110, 0, 0.1);
`;

const MoreVertIcon = styled(InnoIcons.MoreVertIcon)`
  font-size: 18px;
  cursor: pointer;
  color: ${theme.colors.modernPrimary};
  transition: ${theme.modernTokens.transitions.normal};

  &:hover {
    color: ${theme.colors.modernSecondary};
    transform: scale(1.1);
  }
`;

const ParagaphStyle = styled.p`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
  margin-block: 0px;
  padding-block: 0px;
  height: 15px;
  color: ${theme.colors.modernGray[600]};
  font-weight: 500;
`;

const SC = {
  Container,
  BodyHeader,
  BodyContainer,
  HeadingTag,
  FilterContainer,
  FilterOption,
  ActiveContainer,
  ImageContainer,
  Image,
  ProjectDiv,
  PropertyName,
  Status,
  Email,
  Table,
  Thead,
  Tbody,
  TR,
  Th,
  Tr,
  Td,
  InputStyle,
  SearchIcon,
  InputContiner,
  HeaderContainer,
  HeaderStyle,
  CountStyle,
  TabDiv,
  PopoverContainer,
  PopoverSpan,
  MoreVertIcon,
  ParagaphStyle,
};

export default SC;
